import { render, staticRenderFns } from "./AddStaticDataPopup.vue?vue&type=template&id=06a938ad&scoped=true&"
import script from "./AddStaticDataPopup.vue?vue&type=script&lang=js&"
export * from "./AddStaticDataPopup.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/popup.css?vue&type=style&index=0&id=06a938ad&scoped=true&lang=css&"
import style1 from "./AddStaticDataPopup.vue?vue&type=style&index=1&id=06a938ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a938ad",
  null
  
)

export default component.exports